import React, { useEffect } from "react";

const FullScreenLoader = () => {
  useEffect(() => {
    // Inject keyframes only once
    const styleId = "fullscreen-loader-keyframes";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div style={styles.overlay}>
      <div style={styles.spinner}></div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  spinner: {
    width: "60px",
    height: "60px",
    border: "8px solid #f3f3f3",
    borderTop: "8px solid #0e766e",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

export default FullScreenLoader;
